import { Alert, Dialog, Stack, TextField } from '@all-manager/design-system-v2';
import { Controller } from 'react-hook-form';
import useCreateEditDocumentTypeModal, { Props } from './useCreateEditDocumentTypeModal';

export default function CreateEditDocumentTypeModal(props: Props) {
  const hook = useCreateEditDocumentTypeModal(props);

  // Own theme scope: also opened from the legacy DocumentTypeSelect.
  return (
    <Dialog
      open
      onClose={props.onClose}
      onSubmit={hook.onSubmit}
      maxWidth="xs"
      fullWidth
      title={hook.isEdit ? 'Renommer le type de document' : 'Créer un type de document'}
      closeLabel="Fermer"
      actions={{
        primaryAction: {
          label: hook.isEdit ? 'Enregistrer' : 'Créer',
          type: 'submit',
          loading: hook.isSubmitting,
        },
        secondaryAction: {
          label: 'Annuler',
          onClick: props.onClose,
          disabled: hook.isSubmitting,
        },
      }}
    >
      <Stack spacing={3}>
        {hook.serverError ? <Alert severity="error">{hook.serverError}</Alert> : null}

        <Controller
          name="name"
          control={hook.form.control}
          render={({ field, fieldState }) => (
            <TextField
              name={field.name}
              inputRef={field.ref}
              onBlur={field.onBlur}
              onChange={field.onChange}
              value={field.value}
              label="Nom du type"
              placeholder="Ex : Assurance, Diagnostic…"
              autoComplete="off"
              autoFocus
              required
              fullWidth
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
            />
          )}
        />
      </Stack>
    </Dialog>
  );
}
